import Skeleton from 'react-loading-skeleton'
import Card from './Card'

interface ListProps {
  children: React.ReactNode
  className?: string
  id?: string
}

const List = ({ children, className = '', id = 'list' }: ListProps) => (
  // eslint-disable-next-line react/jsx-no-useless-fragment
  <>
    {children ? (
      <Card id={id} className={`py-0 bg-white w-full px-6 my-6 ${className}`}>
        <ul className='w-full'>{children}</ul>
      </Card>
    ) : (
      <Skeleton height={350} className='mt-2' />
    )}
  </>
)

interface ListItemProps {
  name: string
  value: React.ReactNode
  isLoading?: boolean
}

export const ListItem = ({ name, value, isLoading = false }: ListItemProps) => (
  <li className='border-gray-500 flex border-b border-solid last:border-b-0 py-4 font-medium text-xs leading-140'>
    {isLoading ? (
      <Skeleton height={17} />
    ) : (
      <p>
        <span className='text-gray-900 capitalize'>{name}: </span>{' '}
        <span className='font-bold ml-1 text-color-black'>{value}</span>
      </p>
    )}
  </li>
)

export default List
